/* eslint-disable new-cap */
export default function parseTimeMomentJS(time) {
  let moment = require('moment');
  let hours = new moment(time * 1000);
  return hours.format('H:mm')
}
